// extracted by mini-css-extract-plugin
export default {"container":"styles_container__z6tY1","center":"styles_center__6Eh3Y","warning":"styles_warning__NKx6f"};